import _ from 'lodash';
window._ = _;

import * as Bootstrap from 'bootstrap'
window.bootstrap = Bootstrap;

import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Prefix an internal path with the current locale, the way LocalizedUrl::path() does on the
 * server. Russian pages live under /ru; English, being the fallback, has no prefix of its own.
 *
 * Only for links the user navigates to. Data endpoints are deliberately left unprefixed —
 * SetUserLocale does not redirect them, and the locale is already in the session.
 */
window.localizedPath = (path) => {
    const prefix = document.querySelector('meta[name="locale-prefix"]')?.getAttribute('content') || '';

    if (!prefix || path === prefix || path.startsWith(`${prefix}/`)) {
        return path;
    }

    return prefix + path;
};

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER ?? '',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    wsHost: import.meta.env.VITE_PUSHER_HOST,
    wsPort: import.meta.env.VITE_PUSHER_PORT,
    wssPort: import.meta.env.VITE_PUSHER_PORT,
    forceTLS: true,
    encrypted: true,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: '/chat/auth'
});
